import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    quote: "I don't need Salesforce. I just need smart contacts in Outlook.",
    author: "Sarah M.",
    role: "Sales Manager",
    rating: 5,
  },
  {
    quote: "Finally — CRM features without the CRM price tag.",
    author: "Michael K.",
    role: "Consultant",
    rating: 5,
  },
  {
    quote: "The credit system is genius. I pay for AI when I need it, not every month.",
    author: "Lisa R.",
    role: "Executive Assistant",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Loved by professionals who live in Outlook.
          </h2>
          <p className="text-xl text-muted-foreground">
            Join thousands of users who get CRM intelligence without CRM complexity.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-card rounded-2xl p-8 shadow-card border border-border relative"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-primary/20" />
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              
              <p className="text-lg text-foreground mb-6 leading-relaxed italic">
                "{testimonial.quote}"
              </p>
              
              <div className="pt-4 border-t border-border">
                <div className="font-semibold text-foreground">{testimonial.author}</div>
                <div className="text-sm text-muted-foreground">{testimonial.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
